import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'auth-check-email-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.css']
})
export class CheckEmailClientComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
